<template>
  <div id="app">
    <div class="super-user-row mt-4" v-if="currentUserIsSuperAdmin">
      <div class="standard-field-wrapper bg-gray-100 rounded-md">
        <label style="line-height: 2.0rem; padding-top:0.25rem;" class="pl-6" for="super_admin_toggle">Super Admin</label>
        <div class="standard-input-wrapper">
          <div class="standard-input-container checkbox">
            <div class="flex items-start">
              <div class="flex items-center h-11">
                <input v-model="userIsSuperAdmin" class="form-checkbox" type="checkbox" name="super_admin_toggle" :disabled="userIsExec" id="super_admin_toggle">
              </div>
              <div class="pl-7 text-sm" style="line-height: 2.6rem;">
                <p class="text-gray-500">This user can do anything in the system.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="exec-user-row mt-4" v-if="currentUserIsSuperAdmin">
      <div class="standard-field-wrapper bg-gray-100 rounded-md">
        <label style="line-height: 2.0rem; padding-top:0.25rem;" class="pl-6" for="exec_toggle">Executive</label>
        <div class="standard-input-wrapper">
          <div class="standard-input-container checkbox">
            <div class="flex items-start">
              <div class="flex items-center h-11">
                <input v-model="userIsExec" class="form-checkbox" :disabled="userIsSuperAdmin" type="checkbox" name="exec_toggle" id="exec_toggle">
              </div>
              <div class="pl-7 text-sm" style="line-height: 2.6rem;">
                <p class="text-gray-500">This user can view (but not change) anything in the system.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="super-user-row mt-4" v-if="currentUserIsSuperAdmin">
      <div class="standard-field-wrapper bg-gray-100 rounded-md">
        <label style="line-height: 2.0rem; padding-top:0.25rem;" class="pl-6">Associate with Person</label>
        <div class="standard-input-wrapper">
          <div class="standard-input-container checkbox">
            <div class="flex items-start">
              <div class="p-4">
                <div class="flex flex-row">
                  <a v-if="selectedPerson" :href="`/people/${selectedPerson ? selectedPerson.id : null}`" class="mr-4">
                    {{ selectedPerson.name }}
                  </a>
                  <div v-else class="mr-4"> 
                    {{ 'No Person Association' }}
                  </div>

                  <OpenModalButton modalName="PersonLinkageModal" :params="{ resultCb: personLinkageModalCallback }">
                    <svg width="24" height="24" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                      viewBox="0 0 488.1 488.1" style="enable-background:new 0 0 488.1 488.1;" xml:space="preserve">
                      <g>
                        <g>
                          <path d="M299.9,86.8c14.2-6.3,30.3-9.8,46.2-9.8c9.2,0,18,1.1,26.3,3.2c3.3,0.8,6.5-2,6-5.4l-1.2-9.6l0,0
                            c-1-16-19.3-28.9-41.2-28.9c-22.5,0-44,13.5-44,30.2l1,16C293.3,86,296.8,88.2,299.9,86.8z"/>
                          <path d="M487.3,361.9l-0.5-2.9c0-0.2-0.1-0.4-0.1-0.6l-18.5-94c-2.4-21.7-18.2-40.6-41.2-52.3l-8.8-68.3c0-29-32.8-52.7-72.1-52.7
                            s-76.7,23.5-76.7,52.6c0,1.4,0.1,2.9,0.3,4.3l0.5,7.4c-7.8-2.8-16.7-4.4-26.1-4.4c-9.5,0-18.4,1.6-26.3,4.5l0.5-7.5
                            c0.2-1.4,0.3-2.8,0.3-4.3c0-29-37.5-52.6-76.7-52.6c-39.3,0-72.1,23.7-72.1,52.7L61,212.1c-23,11.6-38.8,30.6-41.2,52.3l-18.5,94
                            c0,0.2-0.1,0.4-0.1,0.6l-0.5,2.9l0,0c-0.4,3-0.7,6-0.7,9.1c0,44.6,46.7,80.8,104.2,80.8s104.2-36.2,104.2-80.8l0,0l0,0v-37
                            c10.3,4.8,22.6,7.5,35.7,7.5s25.3-2.7,35.6-7.4V371l0,0l0,0c0,44.6,46.7,80.8,104.2,80.8c57.4,0,104.2-36.2,104.2-80.8
                            C488,367.9,487.7,364.9,487.3,361.9z M104.2,422.7c-40.7,0-75.1-23.7-75.1-51.7c0-28.1,34.4-51.7,75.1-51.7s75.1,23.7,75.1,51.7
                            C179.3,399,144.9,422.7,104.2,422.7z M244.1,315.9c-17.1,0-31-9.7-31-21.6s13.9-21.6,31-21.6s31,9.7,31,21.6
                            C275.1,306.2,261.2,315.9,244.1,315.9z M383.8,422.7c-40.7,0-75.1-23.7-75.1-51.7c0-28.1,34.4-51.7,75.1-51.7s75.1,23.7,75.1,51.7
                            S424.5,422.7,383.8,422.7z"/>
                          <path d="M115.5,80.2c8.3-2.1,17.2-3.2,26.3-3.2c15.9,0,32.1,3.5,46.2,9.8c3.1,1.4,6.6-0.8,6.8-4.2l1-16c0-16.7-21.5-30.2-44-30.2
                            c-21.9,0-40.1,12.9-41.2,28.9l0,0l-1.2,9.6C109,78.2,112.1,81.1,115.5,80.2z"/>
                        </g>
                      </g>
                    </svg>
                  </OpenModalButton>
                </div>

                <button class="mt-2 btn btn-primary" v-show="associationChangePending" @click="linkUserToPerson(selectedPerson)">
                  {{ isSavingAssociation ? 'Saving ...' : 'Save Change' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="country-permissions-area table w-full mt-6 mb-6" v-if="!isAdmin">
      <thead class="">
        <tr>
          <th class="bg-blue-600 text-white">Office</th>
          <th class="bg-blue-600 text-white">Permissions</th>
          <!-- <th class="bg-blue-600 text-white">Field Rep Permissions</th> -->
          <th class="bg-blue-600 text-white">Can Validate Report?</th>
          <th class="bg-blue-600 text-white">Can Report an Expense?</th>
        </tr>
      </thead>
      <tbody>
        <tr class="permission-row" v-for="office in offices" :key="office.id">
          <td class="name">{{ office.name }}</td>
          <td class="virtual-role-seletor">
            <select :class="determineClass(office.id, 'office')" v-model="rolesByOffice[office.id].selector" @change="onVirtualRoleChangeOffice(office.id, $event)">
              <option value="none">None</option>
              <option value="view-only">View Only</option>
              <option value="manage-view-only">Manage - View Only</option>
              <option value="view-update">View & Update</option>
              <option value="manage">Manage</option>
            </select>
          </td>
          <!-- <td class="virtual-role-seletor">
            <select v-model="rolesByOffice[office.id].field_rep_selector" @change="onFieldRepRoleChangeOffice(office.id, $event)">
              <option value="none">None</option>
              <option value="field-rep">Field Rep</option>
              <option value="field-rep-manage">Manage</option>
            </select>
          </td> -->
          <td class="validate-role"><PermissionCheck v-model="rolesByOffice[office.id].validate" /></td>
          <td class="validate-role"><PermissionCheck v-model="rolesByOffice[office.id].expense_report" /></td>
        </tr>
      </tbody>
    </table>

    <table class="country-permissions-area table w-full" v-if="!isAdmin">
      <thead class="bg-blue-500">
        <tr>
          <th class="bg-blue-600 text-white">Country</th>
          <th class="bg-blue-600 text-white">Permissions</th>
          <th class="bg-blue-600 text-white">Coordinator Permissions</th>
          <th class="bg-blue-600 text-white">Can Validate Report?</th>
          <th class="bg-blue-600 text-white">Can Report an Expense?</th>
        </tr>
      </thead>
      <tbody>
        <tr class="permission-row" v-for="country in countries" :key="country.id">
          <td class="name">{{ country.name }}</td>
          <td class="virtual-role-seletor">
            <select :class="determineClass(country.id, 'country')" v-model="rolesByCountry[country.id].selector" @change="onVirtualRoleChangeCountry(country.id, $event)">
              <option value="none">None</option>
              <option value="view-only">View Only</option>
              <option value="manage-view-only">Manage - View Only</option>
              <option value="view-update">View & Update</option>
              <option value="manage">Manage</option>
            </select>
          </td>
          <td class="virtual-role-seletor">
            <select :class="determineClass(country.id, 'field_rep')" v-model="rolesByCountry[country.id].field_rep_selector" @change="onFieldRepRoleChangeCountry(country.id, $event)">
              <option value="none">None</option>
              <option value="field-rep">Coordinator</option>
              <option value="field-rep-manage">Manage</option>
            </select>
          </td>
          <td class="validate-role"><PermissionCheck v-model="rolesByCountry[country.id].validate" /></td>
          <td class="validate-role"><PermissionCheck v-model="rolesByCountry[country.id].expense_report" /></td>
        </tr>
      </tbody>
    </table>

    <button class="mt-6 px-4 py-2 border text-sm leading-5 font-medium rounded-md focus:outline-0 transition duration-150 ease-in-out border-transparent text-white bg-blue-600 hover:bg-blue-500 focus:ring-blue focus:border-blue-700 active:bg-blue-700" @click="submitRoles">
      {{ isSaving ? 'Saving...' : 'Save Permissions' }}
    </button>
  </div>
</template>

<script setup>
  import axios from 'axios'
  import OpenModalButton from '@components/general/OpenModalButton.vue'
  import PermissionCheck from '@components/permission_check.vue'
  import FlashMessages from '@services/FlashMessages'
  import { onMounted, ref, computed } from 'vue'

  const countries = ref(window.gon.imetricsData.countries)
  const offices = ref(window.gon.imetricsData.offices)
  const user = ref(window.gon.imetricsData.user)
  const currentUser = ref(window.gon.current_user)

  let associationChangePending = ref(false)
  let isSavingAssociation = ref(false)
  let selectedPerson = ref(gon.current_person)
  let people = ref(JSON.parse(gon.people))
  let isSaving = ref(false)
  let userIsSuperAdmin = ref(user.value.roles.some(r => r.name === 'super_admin'))
  let userIsExec = ref(user.value.roles.some(r => r.name === 'view_all'))
  let currentUserIsSuperAdmin = ref(currentUser.value.roles.some(r => r.name === 'super_admin'))

  onMounted(() => {
  })

  const isAdmin = computed(() => {
    return userIsSuperAdmin.value || userIsExec.value
  })

  const computedRoles = computed(() => {
    let roles = []

    if (userIsSuperAdmin.value) {
      roles.push({
        role_name: 'super_admin',
        resource_type: null,
        resource_id: null,
      })
    }

    if (userIsExec.value) {
      roles.push({
        role_name: 'view_all',
        resource_type: null,
        resource_id: null,
      })
    }

    const officeRoles = ['read', 'audit', 'write', 'validate', 'manage', 'expense_report', 'field_rep', 'field_rep_manage']
    for (const officeId in rolesByOffice.value) {
      officeRoles.forEach((roleName) => {
        if (rolesByOffice.value[officeId][roleName]) {
          roles.push({
            role_name: roleName,
            resource_type: 'Office',
            resource_id: officeId,
          })
        }
      })
    }

    const countryRoles = ['read', 'audit', 'write', 'validate', 'manage', 'expense_report', 'field_rep', 'field_rep_manage']
    for (const countryId in rolesByCountry.value) {
      countryRoles.forEach((roleName) => {
        if (rolesByCountry.value[countryId][roleName]) {
          roles.push({
            role_name: roleName,
            resource_type: 'Country',
            resource_id: countryId,
          })
        }
      })
    }

    return roles
  })

  const rolesByCountry = computed(() => {
    let d = {}

    countries.value.forEach((c) => {
      const rolesFound = user.value.roles.filter(ur => ur.resource_type === 'Country' && ur.resource_id === c.id )
      
      d[c.id] = {
        read: !!rolesFound.find(ur => ur.name === 'read'),
        audit: !!rolesFound.find(ur => ur.name === 'audit'),
        write: !!rolesFound.find(ur => ur.name === 'write'),
        manage: !!rolesFound.find(ur => ur.name === 'manage'),
        validate: !!rolesFound.find(ur => ur.name === 'validate'),
        expense_report: !!rolesFound.find(ur => ur.name === 'expense_report'),
        field_rep: !!rolesFound.find(ur => ur.name === 'field_rep'),
        field_rep_manage: !!rolesFound.find(ur => ur.name === 'field_rep_manage'),
      }

      d[c.id].selector = determinePermission(d, c)
      d[c.id].field_rep_selector = determinePermissionWithFrs(d, c)
    })

    return d
  })

  const rolesByOffice = computed(() => {
    let d = {}

    offices.value.forEach((c) => {
      const rolesFound = user.value.roles.filter(ur => ur.resource_type === 'Office' && ur.resource_id === c.id )

      d[c.id] = {
        read: !!rolesFound.find(ur => ur.name === 'read'),
        audit: !!rolesFound.find(ur => ur.name === 'audit'),
        write: !!rolesFound.find(ur => ur.name === 'write'),
        validate: !!rolesFound.find(ur => ur.name === 'validate'),
        manage: !!rolesFound.find(ur => ur.name === 'manage'),
        expense_report: !!rolesFound.find(ur => ur.name === 'expense_report'),
        field_rep: !!rolesFound.find(ur => ur.name === 'field_rep'),
        field_rep_manage: !!rolesFound.find(ur => ur.name === 'field_rep_manage'),
      }

      d[c.id].selector = determinePermission(d, c)
      d[c.id].field_rep_selector = determinePermissionWithFrs(d, c)
    })

    return d
  })


  function determineClass(id, selector) {
    let returnVal = ''

    if (selector == "field_rep") {
      returnVal = rolesByCountry.value[id].field_rep_selector != "none" ? 'bg-zinc-300 text-blue-600' : ''
    }

    if (selector == "country") {
      returnVal = rolesByCountry.value[id].selector != "none" ? 'bg-zinc-300 text-blue-600' : ''
    }

    if (selector == "office") {
      returnVal = rolesByOffice.value[id].selector != "none" ? 'bg-zinc-300 text-blue-600' : ''
    }

    return returnVal
  }

  function setSelectedColor(event, c1, c2) {
    event.target.style.color = c1
    event.target.style.background = c2
  }

  function handleToggle(value) {
    console.log("value", value)

    console.log("rolesByOffice[office.id].validate", rolesByOffice.value)
  }

  function determinePermission(array, country) {
    const x = array[country.id]

    if (!x.read && !x.write && !x.manage) {
      return 'none'
    } else if (x.read && !x.audit && !x.write && !x.manage) {
      return 'view-only'
    } else if (x.read && x.audit && !x.write && !x.manage) {
      return 'manage-view-only'
    } else if (x.read && x.write && !x.manage) {
      return 'view-update'
    } else if (x.read && x.write && x.manage) {
      return 'manage'
    }
  }

  function determinePermissionWithFrs(array, country) {
    const x = array[country.id]

    if (!x.field_rep_manage && !x.field_rep) {
      return 'none'
    } else if (!x.field_rep_manage && x.field_rep) {
      return 'field-rep'
    } else if (x.field_rep_manage && x.field_rep) {
      return 'field-rep-manage'
    }
  }

  function personLinkageModalCallback (result) {
    selectedPerson.value = result
    associationChangePending.value = true
  }

  function hasOfficeRole (roleName, office) {
    return !!user.value.roles.find(r => r.resource_type === 'Office' && r.resource_id === office.id && r.name === roleName)
  }

  function hasCountryRole (roleName, office) {
    return !!user.value.roles.find(r => r.resource_type === 'Country' && r.resource_id === office.id && r.name === roleName)
  }

  function onFieldRepRoleChangeOffice(officeId, event) {
    if (event.target.value === 'none') {
      rolesByOffice.value[officeId]['field_rep'] = false
      rolesByOffice.value[officeId]['field_rep_manage'] = false
    } else if (event.target.value === 'field-rep') {
      rolesByOffice.value[officeId]['field_rep'] = true
      rolesByOffice.value[officeId]['field_rep_manage'] = false
    } else if (event.target.value === 'field-rep-manage') {
      rolesByOffice.value[officeId]['field_rep'] = true
      rolesByOffice.value[officeId]['field_rep_manage'] = true
    }
  }

  function onVirtualRoleChangeOffice(officeId, event) {
    console.log(event)

    if (event.target.value === 'none') {
      rolesByOffice.value[officeId]['read'] = false
      rolesByOffice.value[officeId]['audit'] = false
      rolesByOffice.value[officeId]['write'] = false
      rolesByOffice.value[officeId]['manage'] = false
      rolesByOffice.value[officeId]['validate'] = false

      setSelectedColor(event, "black", "white")
    } else if (event.target.value === 'view-only') {
      rolesByOffice.value[officeId]['read'] = true
      rolesByOffice.value[officeId]['audit'] = false
      rolesByOffice.value[officeId]['write'] = false
      rolesByOffice.value[officeId]['manage'] = false
      rolesByOffice.value[officeId]['validate'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'manage-view-only') {
      rolesByOffice.value[officeId]['read'] = true
      rolesByOffice.value[officeId]['audit'] = true
      rolesByOffice.value[officeId]['write'] = false
      rolesByOffice.value[officeId]['manage'] = false
      rolesByOffice.value[officeId]['validate'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'view-update') {
      rolesByOffice.value[officeId]['read'] = true
      rolesByOffice.value[officeId]['audit'] = false
      rolesByOffice.value[officeId]['write'] = true
      rolesByOffice.value[officeId]['manage'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'manage') {
      rolesByOffice.value[officeId]['read'] = true
      rolesByOffice.value[officeId]['audit'] = false
      rolesByOffice.value[officeId]['write'] = true
      rolesByOffice.value[officeId]['manage'] = true
      rolesByOffice.value[officeId]['validate'] = true

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    }
  }

  function onFieldRepRoleChangeCountry(countryId, event) {
    if (event.target.value === 'none') {
      rolesByCountry.value[countryId]['field_rep'] = false
      rolesByCountry.value[countryId]['field_rep_manage'] = false

      setSelectedColor(event, "black", "white")
    } else if (event.target.value === 'field-rep') {
      rolesByCountry.value[countryId]['field_rep'] = true
      rolesByCountry.value[countryId]['field_rep_manage'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'field-rep-manage') {
      rolesByCountry.value[countryId]['field_rep'] = true
      rolesByCountry.value[countryId]['field_rep_manage'] = true

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    }
  }

  function onVirtualRoleChangeCountry(countryId, event) {
    if (event.target.value === 'none') {
      rolesByCountry.value[countryId]['read'] = false
      rolesByCountry.value[countryId]['audit'] = false
      rolesByCountry.value[countryId]['write'] = false
      rolesByCountry.value[countryId]['manage'] = false
      rolesByCountry.value[countryId]['validate'] = false

      setSelectedColor(event, "black", "white")
    } else if (event.target.value === 'view-only') {
      rolesByCountry.value[countryId]['read'] = true
      rolesByCountry.value[countryId]['audit'] = false
      rolesByCountry.value[countryId]['write'] = false
      rolesByCountry.value[countryId]['manage'] = false
      rolesByCountry.value[countryId]['validate'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'manage-view-only') {
      rolesByCountry.value[countryId]['read'] = true
      rolesByCountry.value[countryId]['audit'] = true
      rolesByCountry.value[countryId]['write'] = false
      rolesByCountry.value[countryId]['manage'] = false
      rolesByCountry.value[countryId]['validate'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'view-update') {
      rolesByCountry.value[countryId]['read'] = true
      rolesByCountry.value[countryId]['audit'] = false
      rolesByCountry.value[countryId]['write'] = true
      rolesByCountry.value[countryId]['manage'] = false

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    } else if (event.target.value === 'manage') {
      rolesByCountry.value[countryId]['read'] = true
      rolesByCountry.value[countryId]['audit'] = false
      rolesByCountry.value[countryId]['write'] = true
      rolesByCountry.value[countryId]['manage'] = true
      rolesByCountry.value[countryId]['validate'] = true

      setSelectedColor(event, "#2563eb", "#d4d4d8")
    }
  }

  function submitRoles () {
    console.log('bloop')
    isSaving.value = true
    console.log(computedRoles.value)

    return axios.post(`/users/${user.value.id}/user_roles/bulk_update`, {
      roles: computedRoles.value
    }, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    })
    .then(response => {
      isSaving.value = false

      FlashMessages.success('Permissions were saved.')
      return response
    }, error => {
      isSaving.value = false

      FlashMessages.success('We experienced an error saving permissions. Are you allowed to make this change?')
      console.log('error in bulk_update', error)

      window.Rollbar.error('error saving permissions', { error: error })
    })
  }

  function linkUserToPerson(selectedPerson) {
    console.log('linking', selectedPerson)
    console.log('user', user.value)

    return axios.post(`/people/${selectedPerson.id}/associate_with_user`, {
      user_id: user.value.id,
      id: selectedPerson.id
    }, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    })
    .then(response => {
      FlashMessages.success('user linked with person successfully.')

      isSavingAssociation.value = false
      associationChangePending.value = false

      return response
    }, error => {
      FlashMessages.success('We experienced an error when linking user with person.')

      isSavingAssociation.value = false
      associationChangePending.value = false
      
      $rollbar.error('error linking user with person', { error: error })
    })

    // hit a associate_with_user endpoint that will call associate_with_user controller action and link user/person 
  }
</script>


